import styled from 'styled-components';

import { mediaWideNavless } from '@xing-com/layout-tokens';
import {
  scale320,
  scale330,
  scale390,
  spaceL,
  spaceXL,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const ViewCounterHeading = styled(Headline)`
  margin-right: ${spaceXL};
`;

const ViewCounterDetail = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;

  @media (max-width: 882px), ${mediaWideNavless} and (max-width: 1112px) {
    flex-direction: column-reverse;
  }
`;

const DetailLeftSide = styled.div`
  display: flex;
  height: ${scale330};
  margin-right: ${spaceXL};
  max-width: ${scale320};
  width: 100%;

  svg {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 882px), ${mediaWideNavless} and (max-width: 1112px) {
    margin: ${spaceL} 0 0;
  }
`;

const DetailRightSide = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${scale390};
`;

export const Styled = {
  DetailLeftSide,
  DetailRightSide,
  ViewCounterDetail,
  ViewCounterHeading,
};
